<div class="router-wrapper">
    <router-outlet></router-outlet>
</div>
